module.exports = __webpack_public_path__ + "05_medium_gray.028afd85.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/05_medium_gray.png
// module id = eDjz
// module chunks = 0